import { get, patch } from 'vio-libs';
export function getUserSettings(consumerAPI = false) {
    if (!consumerAPI) {
        return get('user-settings');
    }
    return get('v1/user/settings', undefined, true);
}
export function patchUserSettings(userSettings, consumerAPI = false) {
    if (!consumerAPI) {
        return patch('user-settings', {
            data: {
                update: userSettings
            }
        });
    }
    return patch('v1/user/settings', {
        data: Object.assign({}, userSettings)
    }, true);
}
